import type { FC } from 'react';
import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import {
  Box,
  Table,
  TableHead,
  TableRow,
  TableBody,
  Button,
  Alert,
  Card,
  Grid,
} from '@material-ui/core';
import Panel from '../../../components/global/Panel';
import PanelHeader from '../../../components/global/PanelHeader';
import PanelTitle from '../../../components/global/PanelTitle';
import Scrollbar from '../../../components/global/Scrollbar';
import DataMenuReport, {
  MenuReportItem,
} from '../../../utils/data/DataMenuReport';
import TableCellHeader from '../../../components/global/TableCellHeader';
import useIsMountedRef from '../../../hooks/useIsMountedRef';
import GaugeItem from './GaugeItem';
import { onGet, onPost } from '../../../store/actions/global';

const Gauge: FC<any> = ({ onGet: onGetExec, onPost: onPostExec }) => {
  const isMountedRef = useIsMountedRef();
  const [dataGauge, setDataGauge] = useState<MenuReportItem[]>([]);
  const [message, setMessage] = useState('');
  const [success, setSuccess] = useState(false);

  const loadData = async () => {
    const response = await onGetExec({ url: '/admin/gauge' });
    if (response) {
      const { data: dataExist } = response;
      setDataGauge(
        DataMenuReport.map((itemData): MenuReportItem => {
          const itemExist: { minimo: number; medio: number; maximo: number } = dataExist.find((item) => item.id === itemData.id);
          const {
            minimo = 0,
            medio = 0,
            maximo = 0,
          } = !itemExist ? { minimo: 0, medio: 0, maximo: 0 } : itemExist;
          return {
            id: itemData.id,
            title: itemData.title,
            minimo,
            medio,
            maximo,
          };
        }),
      );
    }
  };

  const updateItem = (itemEdit: MenuReportItem) => {
    const newDataGauge = dataGauge.map((item) => {
      if (item.id === itemEdit.id) {
        const itemUpdate: MenuReportItem = {
          ...itemEdit,
        };
        return itemUpdate;
      }
      return item;
    });
    setDataGauge(newDataGauge);
  };

  const saveData = async () => {
    setMessage('');
    const response = await onPostExec({
      url: '/admin/gauge',
      body: { data: dataGauge },
    });
    if (!response) {
      setMessage('No se guardaron los datos');
    } else {
      setMessage('Se guardaron los datos correctamente');
      setSuccess(true);
      setTimeout(() => {
        setMessage('');
        setSuccess(false);
      }, 5000);
    }
  };

  useEffect(() => {
    if (isMountedRef.current) {
      loadData();
    }
  }, []);

  const title = 'Semaforización';
  return (
    <>
      <Helmet>
        <title>
          Dashboard:
          {title}
        </title>
      </Helmet>
      <Panel>
        <PanelHeader>
          <PanelTitle
            title={title}
            subTitlePrim="Administración"
            subTitleSec="Semaforización"
          />
        </PanelHeader>
        <Box pt={2}>
          <Button color="primary" variant="contained" onClick={saveData}>
            Guardar Cambios
          </Button>
        </Box>
        <Box pt={2}>
          <Grid container>
            <Grid item xl={8} md={10} xs={12}>
              <Card>
                <Scrollbar>
                  <Box sx={{ minWidth: 700 }}>
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCellHeader>Reporte</TableCellHeader>
                          <TableCellHeader width="150px">
                            Minimo
                          </TableCellHeader>
                          <TableCellHeader width="150px">Medio</TableCellHeader>
                          <TableCellHeader width="150px">
                            Maximo
                          </TableCellHeader>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {dataGauge.map((item) => (
                          <GaugeItem
                            key={item.id}
                            item={item}
                            onUpdateItem={updateItem}
                          />
                        ))}
                      </TableBody>
                    </Table>
                  </Box>
                </Scrollbar>
                {message && (
                  <Alert severity={success ? 'info' : 'error'}>{message}</Alert>
                )}
              </Card>
            </Grid>
          </Grid>
        </Box>
      </Panel>
    </>
  );
};

export default connect(null, {
  onGet,
  onPost,
})(Gauge);
